<template>
    <div>
        <table class="table table-bordered mb-0">
            <tbody>
            <tr>
                <th class="text-center align-middle" style="width: 10%">项目名称</th>
                <td class="text-left align-middle" colspan="7">{{ projectInfo.projectName }}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 10%">培训基地</th>
                <td class="text-left align-middle" colspan="5">{{ projectInfo.organName }}</td>
                <th class="text-center align-middle" style="width: 10%">联系人</th>
                <td class="text-left align-middle" style="width: 15%">{{ projectInfo.personName }}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 10%">项目批次</th>
                <td class="text-left align-middle" colspan="3">{{ projectInfo.batchName }}</td>
                <th class="text-center align-middle" style="width: 10%">项目类型</th>
                <td class="text-left align-middle" colspan="3">{{ projectInfo.categoryName }}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 10%">对应专业</th>
                <td class="text-left align-middle" colspan="5">{{projectInfo.trainess}}</td>
                <th class="text-center align-middle" style="width: 10%">计划人数</th>
                <td class="text-left align-middle" style="width: 15%">{{ projectInfo.studentCount }}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 10%">开始日期</th>
                <td class="text-left align-middle" style="width: 15%">{{ projectInfo.startDateString }}</td>
                <th class="text-center align-middle" style="width: 10%">结束日期</th>
                <td class="text-left align-middle" style="width: 15%">{{ projectInfo.endDateString }}</td>
                <th class="text-center align-middle" style="width: 10%">课时数</th>
                <td class="text-left align-middle" style="width: 15%">{{ projectInfo.trainLength }}</td>
                <th class="text-center align-middle" style="width: 10%">学分</th>
                <td class="text-left align-middle" style="width: 15%">{{ projectInfo.trainScore }}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 10%">培训对象</th>
                <td class="text-left align-middle" colspan="7">
                    <div class="rich-text-container" v-html="projectImplementationInfo.trainess"></div>
<!--                    <pre v-text="projectImplementationInfo.trainess"></pre>-->

<!--                    {{projectImplementationInfo.trainess}}-->
                </td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 10%">教学目标</th>
                <td class="text-left align-middle" colspan="7">
                    <div class="rich-text-container" v-html="projectImplementationInfo.objective"></div>
<!--                    <pre v-text="projectImplementationInfo.objective"></pre>-->
<!--                    {{// projectImplementationInfo.objective}};-->
                </td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 10%">授课内容</th>
                <td class="text-left align-middle" colspan="7">
                    <div class="rich-text-container" v-html="projectImplementationInfo.trainContent"></div>
<!--                    <pre v-text="projectImplementationInfo.trainContent"></pre>-->
<!--                    {{projectImplementationInfo.trainContent}}-->
                </td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 10%">备注</th>
                <td class="text-left align-middle" colspan="7">{{projectInfo.memo}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import projectApi from "@/utils/api/project";

export default {
    name: "ProjectInfoView",
    props: {
        projectId: {type: String, required: true},
    },
    data: function () {
        return {
            projectInfo: {},
            projectImplementationInfo: {},
        };
    },
    mounted() {
        this.getProjectInfo();
        this.getProjectImplementationInfo();
    },
    methods: {
        getProjectInfo() {
            projectApi.project.getProjectInfo(this.projectId).then(res => {
                this.projectInfo = res.data;
            });
        },
        getProjectImplementationInfo() {
            projectApi.project.implementation.getProjectImplementationInfo(this.projectId).then(res => {
                // this.projectImplementationInfo = res.data;
                let data = res.data;
                data.trainContent = data.trainContent.replaceAll("\n","<br/>");
                data.objective = data.objective.replaceAll("\n","<br/>");
                data.trainess = data.trainess.replaceAll("\n","<br/>");

                this.projectImplementationInfo = data;
            });
        },
    }
}
</script>

<style scoped>

</style>